// frontend/src/utils/dateUtils.js

/**
 * Calcula la edad a partir de una fecha de nacimiento.
 * @param {string} birthdate - Fecha en formato ISO (ej. '1990-06-14')
 * @returns {number|null} Edad o null si la fecha no es válida
 */
export function calculateAge(birthdate) {
  if (!birthdate) return null;
  const birth = new Date(birthdate);
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const m = now.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
    age--;
  }
  return age;
}

/**
 * Formatea una fecha legible en formato dd/mm/yyyy.
 * Acepta fechas con o sin zona horaria.
 *
 * @param {string|null} input - Fecha ISO o YYYY-MM-DD
 * @returns {string} - Fecha en formato dd/mm/yyyy o "—"
 */
export function formatDateForDisplay(input, language = 'en', format = 'short') {
  if (!input || typeof input !== 'string') return '—';

  const date = new Date(input);

  // Configuración de opciones para formato corto y largo
  const optionsShort = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true, // 12-hour format with AM/PM
  };

  const optionsLong = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true, // 12-hour format with AM/PM
  };

  // Definir el formato según el parámetro 'format'
  const options = format === 'short' ? optionsShort : optionsLong;

  // Formatear la fecha según el idioma y el formato
  return new Intl.DateTimeFormat(language, options).format(date);
}

/**
 * Formatea una fecha para campos <input type="date">.
 * Asegura formato 'YYYY-MM-DD' sin alterar el valor.
 *
 * @param {string|null} input - Fecha como string (ISO o YYYY-MM-DD)
 * @returns {string} - Fecha en formato YYYY-MM-DD o string vacío
 */
export function formatDateForInput(input) {
  if (!input) return '';
  return typeof input === 'string'
    ? input.slice(0, 10)
    : '';
}


/**
 * Prepara una fecha para ser enviada al backend (MySQL DATE).
 * Solo recorta el string si ya está en formato válido.
 *
 * @param {string|null} input - Fecha como string
 * @returns {string} - Fecha en formato YYYY-MM-DD
 */
export function formatDateForSQL(input) {
  if (!input) return '';
  return typeof input === 'string' ? input.slice(0, 10) : '';
}
